import React, { useCallback , useEffect, useState } from "react";
import { Card, Row, Col, Button } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { setFilters } from "../loanBalanceSlice";
import SearchListAutoComplete from "../../../../components/SearchListAutoComplete";
import { SearchOutlined } from "@ant-design/icons";
import RecordDateFilter from "../../../../components/filters/RecordDateFilter";
import {
  fetchLoanBalance,
  fetchLoanAccountsBySearch,
} from "../loanBalanceThunk";
import { useLocation, useSearchParams } from "react-router-dom";
import { useDefaultDateRange } from "../../../../hooks/useDefaultDateRange";

const LoanBalanceFilters = ({ messageApi }) => {
  const dispatch = useDispatch();
  const { filters } = useSelector((state) => state.loanBalance);
  const { pathname } = useLocation();
  const [searchParams] = useSearchParams();

  useDefaultDateRange(setFilters, filters, "today");

  // handleFilterChange only queues the update, so running the report right here
  // would still use the old (default) filters — flag it and run it from the
  // next effect, once the drill-down filters have been applied.
  const [drillReady, setDrillReady] = useState(false);
  useEffect(() => {
    const path = pathname.split("/")[3];
    if (path) {
      handleFilterChange("filterType", "Date Wise");
      const fromDate = searchParams.get("fromDate");
      if (fromDate) {
        handleFilterChange("fromDate", fromDate);
      }
      handleFilterChange("toDate", path);
      setDrillReady(true);
    }
  }, []);
  useEffect(() => {
    if (drillReady) handleSubmit();
  }, [drillReady]);

  const handleFilterChange = (field, value) => {
    if (field === "filterType") {
      dispatch(setFilters({ accId: null })); // reset accountId
    }
    dispatch(setFilters({ [field]: value }));
  };

  const searchAccount = useCallback(
    (text) => dispatch(fetchLoanAccountsBySearch(text)),
    [dispatch]
  );

  const handleSubmit = () => {
    if (!filters.filterType) {
      messageApi.warning("Select Filter Type");
      return;
    }
    dispatch(fetchLoanBalance({ filters })).then((res) => {
      if (res.meta.requestStatus === "fulfilled") {
        messageApi.success("Report loaded ✅");
      } else {
        messageApi.error("Failed to fetch report ❌");
      }
    });
  };

  return (
    <Card className="product-replace-filters mb-4 shadow-md rounded-xl">
      <Row
        gutter={[16, 16]}
        align="middle"
        wrap
        style={{ alignItems: "center" }}
      >
        {/* Filter Type */}
        <Col xs={24} sm={12} md={4} lg={6} xl={4}>
          <label>Filter Type</label>
          <SearchListAutoComplete
            optionsList={[
              { sale_id: "All Loan Account", display_text: "All Loan Account" },
              {
                sale_id: "Loan Account Wise",
                display_text: "Loan Account Wise",
              },
              { sale_id: "Date Wise", display_text: "Date Wise" },
            ]}
            value={
              filters.filterType
                ? { value: filters.filterType, label: filters.filterType }
                : undefined
            }
            onSelect={(obj) => {
              if(!obj) {
                handleFilterChange("filterType", null);
                return;
              } 
              handleFilterChange("filterType", obj?.sale_id);
            }}
            placeholder="Filter Type"
            showAddNew={false}
          />
        </Col>

        {/* Account dropdown when Wise */}
        {filters.filterType === "Loan Account Wise" && (
          <Col xs={24} sm={12} md={4} lg={6} xl={4}>
            <label>Search Account</label>
            <SearchListAutoComplete
              entityType="account"
              searchThunk={searchAccount}
              resultSelector={(state) => state.loanBalance.loanAccounts}
              onSelect={(obj) => handleFilterChange("accId", obj?.sale_id)}
              placeholder="Account"
              showAddNew={false}
            />
          </Col>
        )}

        {/* Date filter when Date Wise */}
        {filters.filterType === "Date Wise" && (
          <RecordDateFilter
            filters={filters}
            handleFilterChange={handleFilterChange}
          />
        )}

        <Col
          xs={24}
          sm={12}
          md={8}
          lg={6}
          xl={4}
          style={{ display: "flex", alignItems: "flex-end", height: 58 }}
        >
          <Button
            type="primary"
            icon={<SearchOutlined />}
            onClick={handleSubmit}
            block
            data-testid="report-btn"
          >
            Get Report
          </Button>
        </Col>
      </Row>
      <style>{`
    @media (min-width: 768px) and (max-width: 1024px) {
      .product-replace-filters .ant-row .ant-col {
        flex: 0 0 50% !important;
        max-width: 50% !important;
      }
    }
      @media (min-width: 768px) {
  :where(.css-dev-only-do-not-override-1j5i8gz).ant-col-md-4 {
    max-width: none !important;
    flex: none !important;
  }
}
  `}</style>
    </Card>
  );
};

export default LoanBalanceFilters;
